import {EventEmitter} from 'events';
import {LoadCurrentMerchantInfoEvent, LoadCurrentMerchantInfoListener} from './LoadCurrentMerchantInfoEvent'
import {LoadManageMerchantEvent, LoadManageMerchantEventListener} from "./LoadManageMerchantEvent";
import {ChangeCurrentMerchantEvent, ChangeCurrentMerchantEventListener} from "./ChangeCurrentMerchantEvent";
import {isObject, isString} from "lodash";
import {WxSubMchStateQueryEvent, WxSubMchStateQueryListener} from "./WxSubMchStateQueryEvent";
import {SubmitSubMchMaterialEvent, SubmitSubMchMaterialEventListener} from "./SubmitSubMchMaterialEvent";
import {RefreshTokenEvent, RefreshTokenEventListener} from "./RefreshTokenEvent";
import {BEFORE_EVENT, AFTER_EVENT} from './event';
import {
    AddOnceCustomOrderExportTaskEvent,
    AddOnceCustomOrderExportTaskEventListener,
    AddRepeatCustomOrderExportTaskEvent,
    AddRepeatCustomOrderExportTaskEventListener
} from "./AddCustomOrderExportTaskEvent";
import {
    LoadCustomOrderExportTasksEvent,
    LoadCustomOrderExportTasksEventListener
} from "./LoadCustomOrderExportTaskEvent";
const eventDispatcher = new EventEmitter();
var addedGlobalEventListener = false;

class EventDispatcher {
    static listeners = {};
    static handlers = {};
    static couldBeClass(obj, strict) {
        if (typeof obj != "function") return false;

        var str = obj.toString();

        // async function or arrow function
        if (obj.prototype === undefined) return false;
        // generator function or malformed definition
        if (obj.prototype.constructor !== obj) return false;
        // ES6 class
        if (str.slice(0, 5) == "class") return true;
        // has own prototype properties
        if (Object.getOwnPropertyNames(obj.prototype).length >= 2) return true;
        // anonymous function
        if (/^function\s+\(|^function\s+anonymous\(/.test(str)) return false;
        // ES5 class without `this` in the body and the name's first character
        // upper-cased.
        if (strict && /^function\s+[A-Z]/.test(str)) return true;
        // has `this` in the body
        if (/\b\(this\b|\bthis[\.\[]\b/.test(str)) {
            // not strict or ES5 class generated by babel
            if (!strict || /classCallCheck\(this/.test(str)) return true;

            return /^function\sdefault_\d+\s*\(/.test(str);
        }

        return false;
    }
    static listener (event, listenerClass) {
        let listener = {};
        let callback = null;
        let isListenerInstance = false;
        try {
            if (EventDispatcher.couldBeClass(listenerClass, true)) {
                listener = new listenerClass(EventDispatcher);
                isListenerInstance = true;
            }else{
                callback = listenerClass;
            }
        } catch (e) {
            callback = listenerClass;
        }
        let eventName = isString(event) ? event : event.getEventName();
        const handler = async (event) => {
            eventDispatcher.emit(eventName + BEFORE_EVENT, event);
            let result = null;
            if (isListenerInstance && listener.handle !== undefined) {
                result = await listener.handle(event);
                event['result'] = result;
            } else if (callback) {
                await callback(event);
            }
            eventDispatcher.emit(eventName + AFTER_EVENT, event);
            event['success'](result);
            return result;
        };
        let listeners = EventDispatcher.listeners[eventName] !== undefined ? EventDispatcher.listeners[eventName] : [];
        if (listeners.length > 0) {
            for (let i = 0; i < listeners.length; i++) {
                if (callback === listeners[i] || listener.handle === listeners[i]) {
                    return;
                }
            }
        }
        listeners.push(callback ? callback : listener.handle)
        EventDispatcher.listeners[eventName] = listeners;
        let map = EventDispatcher.handlers[eventName] !== undefined ? EventDispatcher.handlers[eventName] : new WeakMap();
        let oldHandler = map[callback ? callback : listener.handle];
        if (oldHandler !== undefined) {
            eventDispatcher.removeListener(eventName, oldHandler);
        }
        eventDispatcher.addListener(eventName, handler);
        map[callback ? callback : listener.handle] = handler;
        EventDispatcher.handlers[eventName] = map;
        if (listener.before !== undefined) {
            const beforeHandler = async (event) => {
                if (listener.before !== undefined) {
                    await listener.before(event);
                }
                event['success'](event['result']);
            };
            const beforeEvent = eventName + BEFORE_EVENT;
            let map = EventDispatcher.handlers[beforeEvent] !== undefined ? EventDispatcher.handlers[beforeEvent] : new WeakMap();
            let oldHandler = map[listener.before];
            if (oldHandler !== undefined) {
                eventDispatcher.removeListener(beforeEvent, oldHandler);
            }
            eventDispatcher.addListener(beforeEvent, beforeHandler);
            map[listener.before] = beforeHandler;
            EventDispatcher.handlers[beforeEvent] = map;
        }
        if (listener.after !== undefined) {
            const afterHandler = async (event) => {
                if (listener.after !== undefined) {
                    await listener.after(event);
                }
            };
            const afterEvent = eventName + AFTER_EVENT;
            let map = EventDispatcher.handlers[afterEvent] !== undefined ? EventDispatcher.handlers[afterEvent] : new WeakMap();
            let oldHandler = map[listener.after];
            if (oldHandler != null) {
                eventDispatcher.removeListener(afterEvent, oldHandler);
            }
            eventDispatcher.addListener(afterEvent, afterHandler);
            map[listener.before] = afterHandler;
            EventDispatcher.handlers[afterEvent] = map;
        }
    }

    static dispatch (event, eventData = null) {
        let eventName = isString(event) ? event : event.constructor['getEventName']();
        let options = (eventData ? eventData : event);
        options = isObject(options) ? options : {};
        return new Promise((resolve) => {
            let success = options['success'] !== undefined ?  options['success'] : null;
            options['success'] = (res = null) => {
                success && success(res);
                return resolve(res ? res : true);
            }

            options['failed'] = () => {
                return resolve(false);
            }
            return eventDispatcher.emit(eventName, options);
        });
    }

    static remove (event, handler) {
        let eventName = isString(event) ? event : event.getEventName();
        eventDispatcher.removeListener(eventName, handler);
    }
}

if (!addedGlobalEventListener) {
    EventDispatcher.listener(LoadCurrentMerchantInfoEvent, LoadCurrentMerchantInfoListener)
    EventDispatcher.listener(LoadManageMerchantEvent, LoadManageMerchantEventListener)
    EventDispatcher.listener(ChangeCurrentMerchantEvent, ChangeCurrentMerchantEventListener)
    EventDispatcher.listener(WxSubMchStateQueryEvent, WxSubMchStateQueryListener)
    EventDispatcher.listener(SubmitSubMchMaterialEvent, SubmitSubMchMaterialEventListener)
    EventDispatcher.listener(RefreshTokenEvent, RefreshTokenEventListener)
    EventDispatcher.listener(AddOnceCustomOrderExportTaskEvent, AddOnceCustomOrderExportTaskEventListener)
    EventDispatcher.listener(AddRepeatCustomOrderExportTaskEvent, AddRepeatCustomOrderExportTaskEventListener)
    EventDispatcher.listener(LoadCustomOrderExportTasksEvent, LoadCustomOrderExportTasksEventListener)
    addedGlobalEventListener = true;
}

export default EventDispatcher;